// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "npm-async-@vanilla-extract" + "." + "a50f2a18" + ".css"
}